/* eslint-env browser */
import * as React from 'react'
import PropTypes from 'prop-types'

class Main extends React.Component {
  constructor() {
    super()
    this.state = {
      inputValue: '',
    }
  }

  componentWillMount() {
    if (this.props.initialValue) {
      this.setState({
        inputValue: this.props.initialValue,
      })
      this.props.onChange(this.props.initialValue)
    }
  }

  render() {
    const isValid = this.props.valid(this.state.inputValue)
    let validIcon = <span />
    if (isValid) {
      if (!this.props.optional || (this.state.inputValue || '').length > 0) {
        validIcon = (
          <span className="icon is-left">
            <i style={{ color: 'green' }} className="form-icon fas fa-check" />
          </span>
        )
      }
    } else {
      validIcon = (
        <span className="icon is-left">
          <i style={{ color: 'red' }} className="form-icon fas fa-times" />
        </span>
      )
    }
    return (
      <div className="field appearing">
        <div className="field-label is-normal">
          <label className="label" htmlFor={this.props.inputId}>
            {this.props.label}
          </label>
        </div>
        <div className="field-body">
          <div className="field">
            <p className="control has-icons-left">
              <input
                disabled={this.props.disabled}
                className="input"
                type={this.props.inputType}
                id={this.props.inputId}
                placeholder={this.props.placeholder}
                required={!this.props.optional}
                autoCorrect={this.props.autoCorrect}
                autoCapitalize={this.props.autoCapitalize}
                value={this.state.inputValue}
                onChange={e => {
                  const value = this.props.forceUppercase ? (e.target.value || '').toUpperCase() : e.target.value
                  this.setState({
                    inputValue: value,
                  })
                  this.props.onChange(value)
                }}
                style={this.props.forceUppercase ? { textTransform: 'uppercase' } : {}}
              />
              {validIcon}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  initialValue: PropTypes.string,
  valid: PropTypes.func,
  optional: PropTypes.bool,
  inputId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  inputType: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  forceUppercase: PropTypes.bool,
}

Main.defaultProps = {
  initialValue: undefined,
  optional: true,
  forceUppercase: false,
  valid: () => true,
  disabled: false,
  inputType: 'text',
}

export default Main
